var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDental = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 7.5a4.48 4.48 0 0 0-8-2.8 4.48 4.48 0 0 0-8 2.8 4.34 4.34 0 0 0 .13 1L5.65 15 7 20.07a1.25 1.25 0 0 0 2.38.12l1.45-3.84a1.25 1.25 0 0 1 2.34 0l1.45 3.84a1.25 1.25 0 0 0 2.38-.12L18.35 15l1.53-6.43A4.34 4.34 0 0 0 20 7.5Z"
})));
export default SvgDental;